module.exports = "<p>\n  toast works!\n</p>\n"